import { ResourceService } from '@/services';

export default {
  retrieveMSTeamsConfiguration({ commit }, orgId) {
    return ResourceService.getMsTeamsConfiguration(orgId).then(response => {
      commit('setMsTeamsConfiguration', response.data);
      return response.data;
    });
  },

  updateMSTeamsConfiguration({ commit }, msTeamsConfiguration) {
    return ResourceService.upsertMsTeamsConfiguration(msTeamsConfiguration).then(response => {
      commit('setMsTeamsConfiguration', response.data);
      return response.data;
    });
  }
};
